export enum DisplayType {
  Schaeffler,
  Map,
  Satellite,
}
